import React from 'react';
import { useSelector } from 'react-redux';
import { getUserName } from '@redux/selectors/UserSelector';

import Button from 'react-bootstrap/Button';
import creaIcon from '@images/logos/vendor/crea-logo.svg';
import GAEventTracking from '@components/tracking/GAEventTracking';

const CreaDDFWidget = () => {
  const gaEventTracker = GAEventTracking('User');
  const username = useSelector(getUserName);

  return (
    <div className="panel-content text-center rounded" style={{ backgroundColor: '#264887', minHeight: '231px' }}>
      <img alt="CREA-icon" src={creaIcon} className="img-fluid mb-3" style={{ height: '60px' }} />
      <p className="mb-4" style={{ color: 'var(--darkText-2)' }}>
        <strong>CREA DDF® </strong>
        is a managed service to share listings with multiple third-party websites, while providing access to more listings for your own website.
      </p>
      <Button
        onClick={() => {
          window.open('https://www.crea.ca/technology/realtor-ca-for-realtors/realtor-ca-tools/realtor-ca-ddf', '_blank');
          gaEventTracker('Opened CREA DDF', `${username}`);
        }}
        variant="primary"
      >
        <i className="far fa-external-link mr-2" />
        CREA DDF®
      </Button>
    </div>
  );
};

export default CreaDDFWidget;
